import React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Link,
  Stack,
} from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import { Phone } from "@mui/icons-material";

type ContactCardProps = {
  image: string;
  fullName: string;
  position: string;
  phoneNumber: string;
  email: string;
  linkedinURL: string;
};

export const ContactCard: React.FC<ContactCardProps> = (props) => {
  const { image, fullName, position, phoneNumber, email, linkedinURL } = props;

  return (
    <Card
      sx={{
        flex: 1,
        minWidth: 0.3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "transparent",
        boxShadow: "none",
      }}
    >
      <CardMedia
        component="img"
        height="300"
        image={image}
        alt={fullName}
        sx={{
          borderRadius: 4,
        }}
      />
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Typography gutterBottom variant="h6" color={blueGrey[700]}>
          {fullName}
        </Typography>
        <Typography gutterBottom variant="subtitle1" color={blueGrey[500]}>
          {position}
        </Typography>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Phone color="primary" />
          <Link
            sx={{
              cursor: "pointer",
            }}
            href={`tel:${phoneNumber}`}
          >
            {phoneNumber}
          </Link>
        </Stack>
        <Link
          sx={{
            cursor: "pointer",
          }}
          href={`mailto:${email}`}
        >
          {email}
        </Link>
        <Link
          sx={{
            cursor: "pointer",
          }}
          href={linkedinURL}
          target="_blank"
        >
          View linkedin account
        </Link>
      </CardContent>
    </Card>
  );
};
